import { endOfDay, isSameDay, startOfDay } from 'date-fns';

import { DateFormat } from 'shared/entities/date';
import {
  DatePickerDateFormat,
  DatePickerTime
} from 'shared/newEntities/components/DatePicker';

import { TimePart } from '../type';

const formatTimePart = (date: Date, part: TimePart): string => {
  const value = part === TimePart.hours ? date.getHours() : date.getMinutes();

  return value < 10 ? `0${value}` : `${value}`;
};

export const START_OF_DAY_TIME: DatePickerTime = {
  hours: '00',
  minutes: '00'
};

export const END_OF_DAY_TIME: DatePickerTime = {
  hours: '23',
  minutes: '59'
};

export const extractTimeFromDate = (date: Date): DatePickerTime => ({
  hours: formatTimePart(date, TimePart.hours),
  minutes: formatTimePart(date, TimePart.minutes)
});

export const mergeTimeIntoDate = (date: Date, time: DatePickerTime): Date => {
  if (!time) {
    return new Date(date);
  }

  if (
    time.hours === START_OF_DAY_TIME.hours &&
    time.minutes === START_OF_DAY_TIME.minutes
  ) {
    return startOfDay(date);
  }

  if (
    time.hours === END_OF_DAY_TIME.hours &&
    time.minutes === END_OF_DAY_TIME.minutes
  ) {
    return endOfDay(date);
  }

  const result = new Date(date);

  result.setHours(+time.hours);
  result.setMinutes(+time.minutes);
  result.setSeconds(0, 0);

  return result;
};

export const areDatesEqual = (
  a: Date,
  b: Date,
  dateFormat: DatePickerDateFormat
): boolean => {
  if (dateFormat === DateFormat.dayMonthYearTime) {
    return a.getTime() === b.getTime();
  }

  return isSameDay(a, b);
};

const isEndOfCalendarDay = (date: Date, day: Date): boolean =>
  isSameDay(date, day) && date.getTime() === endOfDay(day).getTime();

export const isFullCalendarDayRange = (
  start: Date,
  end: Date,
  day: Date
): boolean =>
  isSameDay(start, day) &&
  start.getTime() === startOfDay(day).getTime() &&
  isEndOfCalendarDay(end, day);
